<template>
  <li class="pd__item" v-if="!item.hasLimit">
    <div class="gutter">
      <p class="pd__desc pd__desc--fast" v-if="item.hasFast">24h</p>
      <div class="img__inner">
        <img class="img-resp"
          :src="item.src"
          :alt="item.name">
      </div>
      <h2 class="pd__name">{{ item.name }}</h2>
      <p class="pd__desc pd__desc--price">{{ item.price }}</p>
      <p class="pd__desc pd__desc--gift" v-if="item.hasGift">贈品</p>
    </div>
  </li>
</template>

<script>
export default {
  props: ['item'],
}
</script>




// WEBPACK FOOTER //
// src/components/Card/CardItemBase.vue